// Convert lowerCamelCase to snake_case
export function camelToSnake(input: string): string {
  return input
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/-/g, "_")
    .toLowerCase();
}

// Convert snake_case to lowerCamelCase
export function snakeToCamel(input: string): string {
  return input.replace(/_([a-z])/g, (_, ch: string) => ch.toUpperCase());
}

// Recursively remap object keys from snake_case to lowerCamelCase
export function remapKeysToCamel(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(remapKeysToCamel);
  }
  if (value && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      out[snakeToCamel(k)] = remapKeysToCamel(v);
    }
    return out;
  }
  return value;
}

// Recursively remap object keys from lowerCamelCase to snake_case
export function remapKeysToSnake(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(remapKeysToSnake);
  }
  if (value && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      out[camelToSnake(k)] = remapKeysToSnake(v);
    }
    return out;
  }
  return value;
}
